import PieChart from "components/PieChart";
import type { PieChartAdapterProps } from "./PieChart.d";

const PieChartAdapter = ({ blok: { variant, text, chartValue } }: PieChartAdapterProps) =>
  <PieChart variant={variant} text={text} chartValue={chartValue} />

export default PieChartAdapter;
